import React from "react";
import { AudioClip, type ClipVariant } from "./AudioClip";

export type Clip = {
  id: string;
  label: string;
  variant: ClipVariant;
  start: number; // seconds
  end: number; // seconds
  heightPx?: number;
  selected?: boolean;
  onClick?: () => void;
  onDragStart?: (e: React.MouseEvent) => void;
  onVolumeDragStart?: (e: React.MouseEvent) => void;
  onDurationResizeStart?: (e: React.MouseEvent) => void;
  onStartResizeStart?: (e: React.MouseEvent) => void;
  onDelete?: () => void;
  waveformUrl?: string;
  waveformStartFrac?: number;
  waveformEndFrac?: number;
  cutMode?: boolean;
  onCut?: (clickXInClip: number) => void;
};

type TrackContentProps = {
  clips: Clip[];
  pxPerSec: number;
  badges?: Array<{ atSec: number; n: number }>;
};

export function TrackContent({ clips, pxPerSec, badges }: TrackContentProps) {
  return (
    <div className="relative h-[88px] border-b border-[#e2e8f0] last:border-b-0 bg-white">
      {clips.map((clip) => (
        <AudioClip
          key={clip.id}
          label={clip.label}
          variant={clip.variant}
          startPx={clip.start * pxPerSec}
          widthPx={Math.max((clip.end - clip.start) * pxPerSec, 36)}
          heightPx={clip.heightPx}
          selected={clip.selected}
          onClick={clip.onClick}
          onDragStart={clip.onDragStart}
          onDurationResizeStart={clip.onDurationResizeStart}
          onStartResizeStart={clip.onStartResizeStart}
          onDelete={clip.onDelete}
          waveformUrl={clip.waveformUrl}
          waveformStartFrac={clip.waveformStartFrac}
          waveformEndFrac={clip.waveformEndFrac}
          cutMode={clip.cutMode}
          onCut={clip.onCut}
        />
      ))}
      {badges?.map((b) => (
        <div
          key={b.n}
          className="absolute z-30 flex h-5 w-5 items-center justify-center rounded-full bg-[#007aff] text-white text-[11px] font-semibold shadow ring-2 ring-white"
          style={{ left: b.atSec * pxPerSec - 10, top: 4 }}
          title={`Partie ${b.n}`}
        >
          {b.n}
        </div>
      ))}
    </div>
  );
}
